import { render, staticRenderFns } from "./ConsumerTable.vue?vue&type=template&id=0b00e2b0&scoped=true&"
import script from "./ConsumerTable.vue?vue&type=script&lang=js&"
export * from "./ConsumerTable.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerTable.vue?vue&type=style&index=0&id=0b00e2b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b00e2b0",
  null
  
)

export default component.exports